<div (clickOutside)="clickOutside()" class="wrapper">
  <div (click)="toggleDropdown()" class="sort-button">
    <i class="icon-SortAscending"></i>
    Sort
  </div>

  @if (isOpen()) {
    <div class="dropdown-body">
      <div class="sort-group">
        <label class="sort-label">Sort by</label>
        <div class="radio-group">
          <label (click)="setSortField('title')" class="custom-radio">
            <input type="radio" name="sortField"
                   aria-label="Title"
                   [checked]="sortModel().sortField === 'title'">
            <span class="radio-mark"></span>
            <span class="radio-text">Title</span>
          </label>
          <label (click)="setSortField('lastModified')" class="custom-radio">
            <input type="radio" name="sortField"
                   aria-label="Modified date"
                   [checked]="sortModel().sortField === 'lastModified'">
            <span class="radio-mark"></span>
            <span class="radio-text">Modified date</span>
          </label>
        </div>
      </div>

      <div class="sort-group">
        <label class="sort-label">Sorting order</label>
        <div class="radio-group">
          <label (click)="setSortOrder(ESortDirection.Asc)" class="custom-radio">
            <input type="radio" name="sortOrder"
                   aria-label="ASC"
                   [checked]="sortModel().sortOrder === ESortDirection.Asc">
            <span class="radio-mark"></span>
            <span class="radio-text">ASC</span>
          </label>
          <label (click)="setSortOrder(ESortDirection.Desc)" class="custom-radio">
            <input type="radio" name="sortOrder"
                   aria-label="DESC"
                   [checked]="sortModel().sortOrder === ESortDirection.Desc">
            <span class="radio-mark"></span>
            <span class="radio-text">DESC</span>
          </label>
        </div>
      </div>

      <div class="sort-group actions">

        <app-button
          [ariaLabel]="'Cancel'|translate"
          (click)="clickOutside()"
          [buttonStyleType]="BUTTON_TYPES.SECONDARY_0">{{ 'Cancel'|translate }}
        </app-button>
        <app-button
          [ariaLabel]="'Cancel'|translate"
          (click)="updateModel()"
          [buttonStyleType]="BUTTON_TYPES.PRIMARY_0">{{ 'Apply'|translate }}</app-button>

      </div>

    </div>
  }

</div>
